<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="div-conteneur bg-white h-10">
  <div class="div-card-row">
    @for (item of homeCards; track item) {
      @if (item.show && (item.title !== 'Demandes d\'avis' || totalDemandeAvis > 0)) {
        <div class="div-card">
          <app-card [item]="item" (onClickEmit)="navigateToCard(item)"></app-card>
        </div>
      }
    }
  </div>
</div>
